import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const ATTACHMENTS = Object.freeze({
  ID: '',
  MIME_TYPE: '',
  FILE_NAME: '',
  FILE_SIZE: 0,
  UPLOADED_AT: '',
  UPLOADED_BY: '',
  URL: '',
  ROLE: '',
});
export const RECORD = generateSchema(ATTACHMENTS);
export const KEYS: any = generateKeys(ATTACHMENTS);

export class Attachments extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get mimeType(): string {
    return this.get(KEYS.MIME_TYPE);
  }

  get fileName(): string {
    return this.get(KEYS.FILE_NAME);
  }

  get fileSize(): number {
    return this.get(KEYS.FILE_SIZE);
  }

  get uploadedAt(): string {
    return this.get(KEYS.UPLOADED_AT);
  }

  get uploadedBy(): string {
    return this.get(KEYS.UPLOADED_BY);
  }

  get url(): string {
    return this.get(KEYS.URL);
  }

  get role(): string {
    return this.get(KEYS.ROLE);
  }
}
